import React, { useEffect } from "react";
import Layout from "../components/Layout";
import PageTitle from "../components/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import { listRomaniaDescription } from "../redux/actions/aboutRomaniaAction";

const RomaniaScreen = () => {
  const dispatch = useDispatch();
  const listRomaniaDescriptionState = useSelector(
    (state) => state.listRomaniaDescription
  );
  const { descriptions } = listRomaniaDescriptionState;
  useEffect(() => {
    dispatch(listRomaniaDescription());
  }, []);
  return (
    <Layout>
      <PageTitle
        title="Romonia"
        description="Romonia Description"
        button="Edit"
        link={`/edit-romania/${descriptions && descriptions.uuid}`}
      />
      <div className="card">
        <div class="card-body">
          <div class="card-title mb-4">
            {/* {descriptions && descriptions.description} */}
            <div
              dangerouslySetInnerHTML={{
                __html: descriptions && descriptions.description,
              }}
            ></div>
          </div>

          {/* <!-- end row --> */}
        </div>
      </div>
    </Layout>
  );
};

export default RomaniaScreen;
